export default LogoutService

/** @ngInject */
function LogoutService(User, ApiService, PotManager) {
    const logout = function () {
        ApiService.resetPromise('userInfo')
        ApiService.resetPromise('features')
        PotManager.resetPot()
        localStorage.removeItem('hideDashboard')
        return User.logout().$promise
    }

    return {
        logout,
    }
}



// WEBPACK FOOTER //
// ./src/services/api/logout.js